module.exports = __webpack_public_path__ + "img/123.d453b4fa.jpg";